import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-live",
  "use": "icon-live-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-live\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 284.444444h1024v739.555556H0V284.444444z m654.222222 369.777778l-284.444444-170.666666v341.333333l284.444444-170.666667z\" p-id=\"10956\" /><path d=\"M56.888889 80.440889L137.443556 0l321.820444 321.820444L378.766222 402.204444zM890.709333 0l80.440889 80.497778-321.820444 321.820444L568.888889 321.877333z\" p-id=\"10957\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/live.svg
// module id = rPQe
// module chunks = 26